import React, { memo } from 'react';

import './FlexRequestShiftConfirmationModal.scss';
import ConfirmationModal from '../ConfirmationModalNew';

const FlexRequestShiftConfirmationModal = ({
	title,
	textContent,
	boxTextContent,
	primaryActionLabel,
	onPrimaryAction,
	secondaryActionLabel,
	onHide,
	showModalFooter = true
}) => {
	return (
		<ConfirmationModal
			size="l"
			title={title}
			onCancel={onHide}
			onConfirm={onPrimaryAction}
			cancelLabel={secondaryActionLabel}
			confirmLabel={primaryActionLabel}
			showCancel={showModalFooter}
			className="flex-request-shift-modal"
			backdropClassName="modal-backdrop-no-show"
			customModalBodyClass="flex-request-shift-modal-body"
			reverseButtons={false}
			showLoadingSpinner={false}
		>
			<div className="text-content">{textContent}</div>
			{boxTextContent && <div className="box-text-content">{boxTextContent}</div>}
		</ConfirmationModal>
	);
};

export default memo(FlexRequestShiftConfirmationModal);
